import React from 'react';
import '../../css/style.css'


const MobileNav = (props) => {
    return (
        <div className={`fixed z-30 mx-[10px] top-0 left-0 right-0 bg-[${props.data.colors[0].colorWhite}] rounded-b-[20px] shadow-lg p-4 sm:hidden`}> 
            <div className="flex items-center justify-between">
                <div>
                    <a href="/">
                        <img src={props.data.logo[1].image} alt={props.data.logo[1].alt} className="w-[139px]" />
                    </a>
                </div>
                <div>
                    <button onClick={props.toggleMenu}>
                        <img src={props.data.burgerRed[0].img} alt="Меню" className="h-8" />
                    </button>
                </div>
            </div>
        </div>
    );
};

export default MobileNav;
